export default __webpack_public_path__ + "img/17d81f815090f2dc689bb69bba7f0126.svg";